module.exports = __webpack_public_path__ + "img/ginny_possessed.aeb720ea.jpg";